import { FC } from 'react';
import { Button, Col, Dropdown, Menu, Row } from 'antd';
import { TbCalendarShare, TbDevices, TbDots, TbLogout } from 'react-icons/tb';

import { AppIcon } from '@/assets';
import { useAccountSessionManager } from '@/hooks/useAccountSessionManager';
import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { DropdownMenuPanel } from '@/shared/components/dropdowns/DropdownPanel';
import EmptyView from '@/shared/components/layouts/views/EmptySection';
import { useMultiAccountStore } from '@/stores/auth/multiAccount';

import Metadata from './meta';

const NotSupported: FC = (): JSX.Element => {
    const { token: themeToken } = useAntDesignTheme();
    const { logoutAccounts } = useAccountSessionManager();
    const accountId = useMultiAccountStore((state) => state.context?.accountId);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
            <Metadata />
            <Row
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: themeToken.colorBgContainer,
                    backdropFilter: 'blur(0.75rem)',
                    WebkitBackdropFilter: 'blur(0.75rem)', // Safari
                    borderBottom: `1px solid ${themeToken.colorBorder}`,
                }}
            >
                <Col span={2} style={{ textAlign: 'left' }}>
                    <img
                        src={AppIcon}
                        height='48'
                        width='48'
                        alt='Countercyclical - App Icon'
                        style={{ margin: '0.25rem', marginLeft: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                            window.open('https://countercyclical.io', '_blank');
                        }}
                    />
                </Col>
                <Col span={22} style={{ textAlign: 'right' }}>
                    <Dropdown
                        trigger={['click']}
                        placement='bottomRight'
                        popupRender={() => (
                            <DropdownMenuPanel>
                                <Menu.Item
                                    key='whatIsCountercyclical'
                                    icon={
                                        <img
                                            alt='Platform Icon'
                                            src={AppIcon}
                                            height={'20rem'}
                                            width={'20rem'}
                                            style={{
                                                verticalAlign: '-0.3rem',
                                                marginRight: '0.375rem',
                                                marginLeft: '-0.175rem',
                                            }}
                                        />
                                    }
                                    onClick={() => {
                                        window.open('https://countercyclical.io', '_blank');
                                    }}
                                >
                                    What is Countercyclical?
                                </Menu.Item>
                                <Menu.Item
                                    key='demo'
                                    icon={<TbCalendarShare size='1rem' />}
                                    onClick={() => {
                                        window.open('https://countercyclical.io/demo', '_blank');
                                    }}
                                >
                                    Schedule a Demo
                                </Menu.Item>
                            </DropdownMenuPanel>
                        )}
                    >
                        <Button
                            style={{
                                backgroundColor: themeToken.colorBgBase,
                                marginTop: '0.75rem',
                                marginRight: '0.5rem',
                            }}
                            type='text'
                        >
                            <TbDots
                                size='1rem'
                                style={{ verticalAlign: '-0.175rem', color: themeToken.colorTextTertiary }}
                            />
                        </Button>
                    </Dropdown>
                </Col>
            </Row>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: '1 1 0%',
                    minHeight: 0,
                    flexDirection: 'column',
                    backgroundColor: themeToken.colorBgContainer,
                }}
            >
                <EmptyView
                    icon={<TbDevices />}
                    height='auto'
                    label='Screen Too Small'
                    description='Countercyclical is not available on mobile or tablet screens yet. Open it on a desktop or laptop to continue.'
                    extra={
                        <Button
                            icon={<TbLogout size='1rem' />}
                            onClick={() => void logoutAccounts(accountId ? [accountId] : undefined)}
                        >
                            Sign Out
                        </Button>
                    }
                />
            </div>
        </div>
    );
};

export default NotSupported;
